var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalloutAllertIcon = function SvgCalloutAllertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#callout-allert-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF4452",
    d: "M5.735 13.673H2.487a.987.987 0 0 1-.987-.987V7.315c0-.546.442-.988.987-.988h3.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F56570",
    d: "M5.734 13.673V6.327l9.237-4.38a.988.988 0 0 1 1.41.892v14.322a.988.988 0 0 1-1.41.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E32939",
    d: "M16.382 8.164h1.13c.545 0 .987.442.987.987v1.698a.987.987 0 0 1-.987.988h-1.13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "callout-allert-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCalloutAllertIcon;